module.exports = __webpack_public_path__ + "static/media/gender-men-primary.8e395ad1.svg";